/** 40px round chevron button used by the day pager and the month calendar. */
import { FC } from "react"
import { Pressable, PressableStateCallbackType, ViewStyle } from "react-native"
import Icon from "react-native-vector-icons/MaterialIcons"

import { webTransition } from "./motion"
import { tokens } from "./tokens"

export interface NavArrowProps {
  direction: "left" | "right"
  label: string
  disabled: boolean
  onPress: () => void
  testID?: string
}

type HoverState = PressableStateCallbackType & { hovered?: boolean }

export const NavArrow: FC<NavArrowProps> = ({ direction, label, disabled, onPress, testID }) => (
  <Pressable
    accessibilityRole="button"
    accessibilityLabel={label}
    accessibilityState={{ disabled }}
    disabled={disabled}
    onPress={onPress}
    testID={testID}
    style={(state) => [
      $arrow,
      (state as HoverState).hovered && !disabled && $hover,
      disabled && $disabled,
    ]}
  >
    <Icon
      name={direction === "left" ? "chevron-left" : "chevron-right"}
      size={20}
      color={tokens.ink}
    />
  </Pressable>
)

const $arrow: ViewStyle = {
  width: 40,
  height: 40,
  borderRadius: 20,
  borderWidth: 1,
  borderColor: tokens.field,
  backgroundColor: tokens.surface,
  alignItems: "center",
  justifyContent: "center",
  ...webTransition("background-color", 150),
}
const $hover: ViewStyle = { backgroundColor: tokens.mist }
const $disabled: ViewStyle = { opacity: 0.35 }
